import React from "react";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { payCaseProgress } from "../../api/caseApi";

const PaymentConfirmed = () => {
  const [searchParams] = useSearchParams();
  console.log(searchParams.get("caseId"));

  useEffect(() => {
    const fetch = async () => {
      const vals = ["caseId", "caseProgressId", "amount", "token"];
      const data = {};
      vals.map((val) => (data[val] = searchParams.get(val)));

      data.transactionNo = data.token;
      data.date = new Date().toISOString();
      delete data.token;

      const response = await payCaseProgress(data);
    };

    fetch();
  }, []);

  return (
    <div
      style={{
        width: "100vh",
      }}
    >
      <div
        style={{
          margin: "0 auto",
        }}
      >
        <div>Payment Confirmed</div>
        <div>Thanks</div>
        <Link to="/">Back</Link>
      </div>
    </div>
  );
};

export default PaymentConfirmed;
